"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

var _reactInputRange = _interopRequireDefault(require("react-input-range"));

var _convertUnits = _interopRequireDefault(require("convert-units"));

var _lodash = require("lodash");

var _utils = require("../SQONView/utils");

var _AggsWrapper = _interopRequireDefault(require("./AggsWrapper"));

var _formatNumber = _interopRequireDefault(require("../utils/formatNumber"));

require("react-input-range/lib/css/index.css");

require("./AggregationCard.css");

require("./RangeAgg.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SUPPORTED_CONVERSIONS = {
  time: ['d', 'year'],
  digital: ['GB']
};

var supportedConversionFromUnit = function supportedConversionFromUnit(unit) {
  return unit ? SUPPORTED_CONVERSIONS[(0, _convertUnits["default"])().describe(unit).measure] : [];
};

var round = function round(x) {
  return Math.round(x * 100) / 100;
};

var RangeLabel = function RangeLabel(_ref) {
  var children = _ref.children,
      isTop = _ref.isTop,
      position = _ref.position,
      props = _objectWithoutProperties(_ref, ["children", "isTop", "position"]);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)("position:absolute;", position === 'right' && "".concat(position, ": 0;"), " top:", isTop ? "-" : "", "1.2rem;"))
  }), children);
};

var getLabelId = function getLabelId(displayName) {
  return "".concat(displayName.split('(')[0].trim().toLowerCase().replace(/\s/g, '-'), "__range-label");
};

var RangeAgg = /*#__PURE__*/function (_Component) {
  _inherits(RangeAgg, _Component);

  var _super = _createSuper(RangeAgg);

  function RangeAgg(props) {
    var _this;

    _classCallCheck(this, RangeAgg);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeComplete", function () {
      var _this$props = _this.props,
          displayName = _this$props.displayName,
          field = _this$props.field,
          handleChange = _this$props.handleChange,
          _this$props$stats = _this$props.stats,
          max = _this$props$stats.max,
          min = _this$props$stats.min;
      var _this$state = _this.state,
          currentValues = _this$state.currentValues,
          displayUnit = _this$state.displayUnit;

      var _map = [currentValues.max, currentValues.min].map(function (x) {
        return round(x);
      }),
          _map2 = _slicedToArray(_map, 2),
          currentMax = _map2[0],
          currentMin = _map2[1];

      return handleChange === null || handleChange === void 0 ? void 0 : handleChange({
        field: {
          displayName: displayName,
          displayUnit: displayUnit,
          field: field
        },
        generateNextSQON: function generateNextSQON(sqon) {
          return (0, _utils.replaceFieldSQON)(field, {
            op: 'and',
            content: [].concat(_toConsumableArray(currentMin > min ? [{
              op: '>=',
              content: {
                field: field,
                value: currentMin
              }
            }] : []), _toConsumableArray(currentMax < max ? [{
              op: '<=',
              content: {
                field: field,
                value: currentMax
              }
            }] : []))
          }, sqon);
        },
        max: currentMax,
        min: currentMin,
        value: currentValues
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setNewUnit", function (event) {
      return _this.setState({
        displayUnit: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setNewValue", function (_ref2) {
      var newMax = _ref2.max,
          newMin = _ref2.min;
      var _this$props$stats2 = _this.props.stats,
          max = _this$props$stats2.max,
          min = _this$props$stats2.min;

      if (round(newMax) <= round(max) && round(newMin) >= round(min)) {
        _this.setState({
          currentValues: {
            max: round(newMax),
            min: round(newMin)
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatRangeLabel", function (value, type) {
      var _this$props2 = _this.props,
          formatLabel = _this$props2.formatLabel,
          unit = _this$props2.unit;
      var displayUnit = _this.state.displayUnit;
      return (formatLabel === null || formatLabel === void 0 ? void 0 : formatLabel(value, type)) || (0, _formatNumber["default"])(unit && displayUnit ? Math.round((0, _convertUnits["default"])(value).from(unit).to(displayUnit) * 100) / 100 : value);
    });

    var sqonValues = props.sqonValues,
        _props$stats = props.stats,
        _props$stats$max = _props$stats.max,
        _max = _props$stats$max === void 0 ? 0 : _props$stats$max,
        _props$stats$min = _props$stats.min,
        _min = _props$stats$min === void 0 ? 0 : _props$stats$min,
        _unit = props.unit;

    var supportedConversions = supportedConversionFromUnit(_unit);
    _this.state = {
      currentValues: {
        max: (sqonValues === null || sqonValues === void 0 ? void 0 : sqonValues.max) || _max,
        min: (sqonValues === null || sqonValues === void 0 ? void 0 : sqonValues.min) || _min
      },
      displayUnit: (supportedConversions === null || supportedConversions === void 0 ? void 0 : supportedConversions.includes(_unit)) ? _unit // use unit selected in Admin UI as default, if available here
      : supportedConversions === null || supportedConversions === void 0 ? void 0 : supportedConversions[0],
      supportedConversions: supportedConversions
    };
    return _this;
  }

  _createClass(RangeAgg, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _nextProps$sqonValues = nextProps.sqonValues;
      _nextProps$sqonValues = _nextProps$sqonValues === void 0 ? {} : _nextProps$sqonValues;
      var sqonMax = _nextProps$sqonValues.max,
          sqonMin = _nextProps$sqonValues.min,
          _nextProps$stats = nextProps.stats;
      _nextProps$stats = _nextProps$stats === void 0 ? {} : _nextProps$stats;
      var newMax = _nextProps$stats.max,
          newMin = _nextProps$stats.min;
      var _this$props$stats3 = this.props.stats;
      _this$props$stats3 = _this$props$stats3 === void 0 ? {} : _this$props$stats3;
      var oldMax = _this$props$stats3.max,
          oldMin = _this$props$stats3.min;
      var _this$state$currentVa = this.state.currentValues;
      _this$state$currentVa = _this$state$currentVa === void 0 ? {} : _this$state$currentVa;
      var selectedMax = _this$state$currentVa.max,
          selectedMin = _this$state$currentVa.min;
      var resetMax = (0, _lodash.isNil)(sqonMax) ? (0, _lodash.isNil)(oldMax) || newMax > oldMax && oldMax === selectedMax : newMax < selectedMax || newMin > selectedMax;
      var resetMin = (0, _lodash.isNil)(sqonMin) ? (0, _lodash.isNil)(oldMin) || newMin < oldMin && oldMin === selectedMin : newMin > selectedMin || newMax < selectedMin;
      this.setState({
        currentValues: {
          max: resetMax ? newMax : Math.min(sqonMax || selectedMax, newMax),
          min: resetMin ? newMin : Math.max(sqonMin || selectedMin, newMin)
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          _this$props3$collapsi = _this$props3.collapsible,
          collapsible = _this$props3$collapsi === void 0 ? true : _this$props3$collapsi,
          _this$props3$displayN = _this$props3.displayName,
          displayName = _this$props3$displayN === void 0 ? 'Unnamed Field' : _this$props3$displayN,
          field = _this$props3.field,
          rangeStep = _this$props3.rangeStep,
          _this$props3$stats = _this$props3.stats,
          max = _this$props3$stats.max,
          min = _this$props3$stats.min,
          step = _this$props3.step,
          type = _this$props3.type,
          WrapperComponent = _this$props3.WrapperComponent;
      var _this$state2 = this.state,
          currentValues = _this$state2.currentValues,
          displayUnit = _this$state2.displayUnit,
          supportedConversions = _this$state2.supportedConversions;
      var hasData = [!(0, _lodash.isNil)(min), !(0, _lodash.isNil)(max)].every(Boolean);

      var dataFields = _objectSpread(_objectSpread({
        'data-available': hasData
      }, field && {
        'data-field': field
      }), type && {
        'data-type': type
      });

      var minIsMax = min === max;
      var unusable = min + rangeStep === max || minIsMax;
      return /*#__PURE__*/_react["default"].createElement(_AggsWrapper["default"], {
        dataFields: dataFields,
        displayName: "".concat(displayName).concat(displayUnit ? " (".concat((0, _convertUnits["default"])().describe(displayUnit).plural, ")") : ""),
        WrapperComponent: WrapperComponent,
        collapsible: collapsible
      }, hasData ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "range-wrapper"
      }, supportedConversions.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "unit-wrapper"
      }, supportedConversions.map(function (x) {
        return (0, _convertUnits["default"])().describe(x);
      }).map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          active: x.abbr === displayUnit
        });
      }).map(function (_ref3) {
        var abbr = _ref3.abbr,
            plural = _ref3.plural,
            active = _ref3.active;
        return /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: abbr,
          key: abbr
        }, /*#__PURE__*/_react["default"].createElement("input", {
          checked: active,
          id: abbr,
          onChange: _this2.setNewUnit,
          type: "radio",
          value: abbr
        }), plural);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-range-wrapper".concat(unusable ? ' disabled' : '')
      }, /*#__PURE__*/_react["default"].createElement(RangeLabel, {
        isTop: true
      }, this.formatRangeLabel(currentValues.min)), !minIsMax && /*#__PURE__*/_react["default"].createElement(RangeLabel, {
        isTop: true,
        position: "right"
      }, this.formatRangeLabel(currentValues.max)), /*#__PURE__*/_react["default"].createElement(_reactInputRange["default"], {
        ariaLabelledby: getLabelId(displayName),
        className: unusable ? 'disabled' : '',
        draggableTrack: true,
        disabled: unusable,
        step: step,
        minValue: min,
        maxValue: max,
        value: currentValues,
        formatLabel: this.formatRangeLabel,
        onChange: this.setNewValue,
        onChangeComplete: this.onChangeComplete
      }), /*#__PURE__*/_react["default"].createElement(RangeLabel, null, this.formatRangeLabel(min)), !minIsMax && /*#__PURE__*/_react["default"].createElement(RangeLabel, {
        position: "right"
      }, this.formatRangeLabel(max)), /*#__PURE__*/_react["default"].createElement("span", {
        id: getLabelId(displayName),
        className: (0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)("position:absolute;height:0;width:0;top:-9999px;left:-9999px;"))
      }, "Set ", displayName))) : /*#__PURE__*/_react["default"].createElement("span", {
        className: "no-data"
      }, "No data available"));
    }
  }]);

  return RangeAgg;
}(_react.Component);

var _default = RangeAgg;
exports["default"] = _default;